// src/Reports.js
import React, { useState, useEffect } from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import DMReportsGrid from '../Components/DMReportsGrid.js';
import HomeHighlightsDM from '../Components/HomeHighlightsDM.js';
import '../CSS/Reports.css';
import '../CSS/PowerBI.css';
import useIsMobile from '../Components/UseIsMobile.js';
import {getStorage} from '../Components/Storage.js';

function Reports() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedSector, setSelectedSector] = useState('');
  const [groupResponsible, setGroupResponsible] = useState('');
  const [targetedEntity, setTargetedEntity] = useState('');
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);
  const [selectedDropdownFilter, setSelectedDropdownFilter] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedIndustryFilter, setSelectedIndustryFilter] = useState('');
  const [access_token, setAccessToken] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [stateSearch, setstatesearch] = useState('');
  const isMobile = useIsMobile();
  const [clients, setClients] = useState([]);
  const [cansee, setcansee] = useState([]);

  const username = getStorage('username');

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSectorChange = (event) => {
    const sector = event.target.value;
    setSelectedSector(sector === selectedSector ? '' : sector); // Toggle the sector
  };

  const handleGroupResponsibleChange = (event) => {
    setGroupResponsible(event.target.value);
  };

  const handleTargetedEntityChange = (event) => {
    setTargetedEntity(event.target.value);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
  };

  const handleClear = () => {
    setSearchTerm('');
    setSelectedSector('');
    setGroupResponsible('');
    setTargetedEntity('');
    setSelectedDropdownFilter('');
    setStartDate('');
    setEndDate('');
    setSelectedIndustryFilter('');
    setSelectedRegion('');
    setstatesearch('');
  };

  const toggleAdvancedSearch = () => {
    setShowAdvancedSearch(prevState => !prevState);
  };

  const applyDropdownFilter = (event) => {
    setSelectedDropdownFilter(event.target.value);
    // Apply logic based on the selected dropdown filter (e.g., trigger API call with the filter)
  };

  const applyIndustryFilter = (event) => {
    setSelectedIndustryFilter(event.target.value);
    // Apply logic based on the selected industry filter (e.g., trigger API call with the filter)
  };

  const handleRegionChange = (event) => {
    const region = event.target.value;
    setSelectedRegion(region === selectedRegion ? '' : region); // Toggle the region
  };

  useEffect(() => {
    // Fetch reports data from your server
    fetch('/api/hello')
      .then((response) => response.json())
      .then((data) => {
        setAccessToken(data.accessToken);
        setClients(data.clients);
      })
      .catch((error) => {
        console.error('Error fetching reports data:', error);
      });
  }, []);

  useEffect(() => {
    if (clients.length > 0) {
        const matchingClient = clients.find(client => client.fields.Email === username);
        if (matchingClient) {
            const isdm = matchingClient.fields.DM;
            if(isdm){
                setcansee(true);
            }
            else{
                setcansee(false);
            }
        }
    }

  });
  
  if (cansee == false) {
    return (
      <div className="reports">
        <p>You don't have access to view this content.</p>
      </div>
    );
  }

  return (
    <div className="reports">
      <h1 className="reports-title">Daily Reports Index</h1>

      {/* Desktop Filters */}
      {!isMobile && (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '20vh', // This sets the height to the full viewport height
          marginTop: '10vh',
          marginBottom: '14vh'
        }}>
          {/* Search and Sector filter */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            </div>
          </div>

          {/* Region Filter */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <h3>State Filter:</h3>
            {[
              'CO',
              'TX',
              'NM',
              'LA',
              'KS',
              'OK',
              'MT',
              'WY',
            ].map((region) => (
              <label
                key={region}
                style={{ color: selectedRegion !== region ? 'white' : '#cab069' }}
              >
                <input
                  type="radio"
                  value={region}
                  checked={selectedRegion === region}
                  onChange={handleRegionChange}
                />
                <span className="region-text"> {region}</span>
              </label>
            ))}
            {/* Clear button */}
            <button onClick={handleClear} className="clear-button">Clear</button>
          </div>
            
          {/* Advanced search row 1 */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <label>Search:&nbsp;
              <input
                type="text"
                placeholder="Search by Title"
                value={searchTerm}
                onChange={handleSearch}
              />
            </label>
            {/* Group Responsible search */}
            <label>
              Group Responsible:&nbsp;
              <input
                type="text"
                placeholder="Search by group"
                value={groupResponsible}
                onChange={handleGroupResponsibleChange}
              />
            </label>
            {/* Type of Report dropdown */}
            <label htmlFor="dropdownFilter">Type of Report:</label>
            <select id="dropdownFilter" value={selectedDropdownFilter} onChange={applyDropdownFilter}>
              <option value="">Select an option</option>
              <option value="protest after-action">Protest After-Action</option>
              <option value="direct action">Direct Action</option>
              <option value="general intel">General Intel</option>
              <option value="infiltration">Infiltration</option>
            </select>
          </div>
    
          {/* Advanced search row 2 */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: '1rem' }}>
            {/* Targeted Industry dropdown */}
            <label htmlFor="industryFilter">Targeted Industry:</label>
            <select id="industryFilter" value={selectedIndustryFilter} onChange={applyIndustryFilter}>
              <option value="">Select an option</option>
              <option value="Fur and Leather">Fur and Leather</option>
              <option value="Hunting">Hunting</option>
              <option value="Research – CRO">Research – CRO</option>
              <option value="Research – Academic">Research – Academic</option>
              <option value="Research – Breeder">Research – Breeder</option>
              <option value="Research – General">Research – General</option>
              <option value="Research – Pharmaceuticals">Research – Pharmaceuticals</option>
              <option value="Research – Transportation">Research – Transportation</option>
              <option value="Research – Government">Research – Government</option>
              <option value="Research – Cosmetics">Research – Cosmetics</option>
              <option value="Research – Other">Research – Other</option>
              <option value="Agriculture – General">Agriculture – General</option>
              <option value="Agriculture – Transportation">Agriculture – Transportation</option>
              <option value="Agriculture – Government">Agriculture – Government</option>
              <option value="Agriculture – Food Services">Agriculture – Food Services</option>
              <option value="Agriculture – Farms">Agriculture – Farms</option>
              <option value="Agriculture – Processing">Agriculture – Processing</option>
              <option value="Entertainment – Government">Entertainment – Government</option>
              <option value="Entertainment – Sports">Entertainment – Sports</option>
              <option value="Entertainment – Zoo/Park">Entertainment – Zoo/Park</option>
              <option value="Pet Industry">Pet Industry</option>
            </select>
    
            {/* Start Date filter */}
            <label>
              Start Date:&nbsp;
              <input
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
                style={{
                  height: '30px',
                  padding: '0 10px',
                  fontSize: '16px',
                  lineHeight: '1.5',
                  boxSizing: 'border-box',
                }}
              />
            </label>
    
            {/* End Date filter */}
            <label>
              End Date:&nbsp;
              <input
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
                style={{
                  height: '30px',
                  padding: '0 10px',
                  fontSize: '16px',
                  lineHeight: '1.5',
                  boxSizing: 'border-box',
                }}
              />
            </label>
          </div>
        </div>
      )}

      {/* Mobile Filters */}
      {isMobile && (
        <div className="mobile-filters">

          {/* 🔹 Region Filter */}
          <details className="filter-section">
            <summary className="filter-header">Region Filter</summary>
            <div className="filter-content">
              {['CO',
              'TX',
              'NM',
              'LA',
              'KS',
              'OK',
              'MT',
              'WY'].map((region) => (
                <label key={region}>
                  <input type="radio" value={region} checked={selectedRegion === region} onChange={(e) => setSelectedRegion(e.target.value)} />
                  {region}
                </label>
              ))}
            </div>
          </details>

          {/* 🔹 Advanced Search */}
          <details className="filter-section advanced-search">
            <summary className="filter-header">Advanced Search</summary>
            <div className="filter-content">
              <label>Search:
                <input type="text" placeholder="Search by Title" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
              </label>
              <label>Group Responsible:
                <input type="text" placeholder="Search by group" value={groupResponsible} onChange={(e) => setGroupResponsible(e.target.value)} />
              </label>
              <label>Targeted Industry:
                <select value={selectedIndustryFilter} onChange={(e) => setSelectedIndustryFilter(e.target.value)}>
                <option value="">Select an option</option>
              <option value="Fur and Leather">Fur and Leather</option>
              <option value="Hunting">Hunting</option>
              <option value="Research – CRO">Research – CRO</option>
              <option value="Research – Academic">Research – Academic</option>
              <option value="Research – Breeder">Research – Breeder</option>
              <option value="Research – General">Research – General</option>
              <option value="Research – Pharmaceuticals">Research – Pharmaceuticals</option>
              <option value="Research – Transportation">Research – Transportation</option>
              <option value="Research – Government">Research – Government</option>
              <option value="Research – Cosmetics">Research – Cosmetics</option>
              <option value="Research – Other">Research – Other</option>
              <option value="Agriculture – General">Agriculture – General</option>
              <option value="Agriculture – Transportation">Agriculture – Transportation</option>
              <option value="Agriculture – Government">Agriculture – Government</option>
              <option value="Agriculture – Food Services">Agriculture – Food Services</option>
              <option value="Agriculture – Farms">Agriculture – Farms</option>
              <option value="Agriculture – Processing">Agriculture – Processing</option>
              <option value="Entertainment – Government">Entertainment – Government</option>
              <option value="Entertainment – Sports">Entertainment – Sports</option>
              <option value="Entertainment – Zoo/Park">Entertainment – Zoo/Park</option>
              <option value="Pet Industry">Pet Industry</option>
                </select>
              </label>
              {/* State search text field here */}
              <label>Start Date:
                <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              </label>
              <label>End Date:
                <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              </label>
            </div>
          </details>

          {/* 🔹 Clear Button */}
          <button onClick={handleClear} className="clear-button">Clear</button>
        </div>
      )}
      <HomeHighlightsDM />

      {/* Render the ReportsGrid component */}
      <DMReportsGrid 
        searchTerm={searchTerm} 
        selectedSector={selectedSector} 
        groupResponsible={groupResponsible}
        targetedEntity={targetedEntity}
        selectedDropdownFilter={selectedDropdownFilter}
        startDate={startDate}
        endDate={endDate}
        selectedIndustryFilter={selectedIndustryFilter}
        selectedRegion={selectedRegion}
        stateSearch={stateSearch}
      />
    </div>
  );
}

export default Reports;
